import { InjectionToken } from '@angular/core';
import { InMemoryCacheConfig } from '@apollo/client/cache';
import { environment } from '@src/environments';

export interface GraphQLConfig {
  url: string;
  inMemoryCache?: InMemoryCacheConfig;
  [key: string]: any;
}

const DEFAULT_GRAPHQL_CONFIG: GraphQLConfig = {
  url: environment.graphQLUrl,
  inMemoryCache: {}
};

export const GRAPHQL_CONFIG = new InjectionToken<GraphQLConfig>('graphql.config', {
  providedIn: 'root',
  factory: () => DEFAULT_GRAPHQL_CONFIG
});